/** The services a campaign page can sell; the website only has booking widgets for these two. */
export enum CampaignPageServiceEnum {
    CHEFIT = "CHEFIT",
    PARTY = "PARTY",
}

/** A thechefkart.com/campaign/{slug} page, as /centaurus/campaign-page returns it. */
export interface CampaignPageResponse {
    id: number;
    slug: string;
    campaignName: string;
    service: CampaignPageServiceEnum;
    metaTitle: string;
    metaDescription: string;
    noindex: boolean;
    bannerHeading: string;
    bannerDescription: string;
    bannerImageUrl: string;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface CreateCampaignPage {
    slug: string;
    campaignName: string;
    service: CampaignPageServiceEnum;
    metaTitle: string;
    metaDescription: string;
    noindex: boolean;
    bannerHeading: string;
    bannerDescription: string;
    bannerImageUrl: string;
    isActive: boolean;
}

/** Everything but the slug: it is the page's URL, and the backend refuses to change it. */
export type UpdateCampaignPage = Partial<Omit<CreateCampaignPage, "slug">>;
